export default {
  cardDefault: '0px 6px 18px rgba(0, 0, 0, 0.06)',
  detectedItem:
    '0px 1px 3px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.08), 0px 2px 1px -1px rgba(0, 0, 0, 0.08)'
};
